// @flow strict

import * as React from 'react'
import cx from 'classnames'

import { type PropsWithChildren } from '@mondough/public-web-components'

import { type TriptychSectionProps } from '../TriptychSection'
import SubtitleSection from '../SubtitleSection'

import styles from './BusinessTriptych.module.scss'
import { SectionWrapper, SectionThemes } from '../SectionWrapper'
import { MarkdownContent } from '../MarkdownContent'

export default function BusinessVerticalTriptych({
  sections,
  reverse,
  children,
}: PropsWithChildren<
  TriptychSectionProps,
  React.Element<typeof SubtitleSection>,
>) {
  return (
    <SectionWrapper
      className={styles.section}
      contentClassName={cx(styles.businessTriptych, styles.vertical)}
      theme={SectionThemes.GREY}
    >
      {children}
      <div className={styles.root}>
        {sections.map(({ title, text, imageURL }) => (
          <div key={title} className={styles.item}>
            <h3 className={styles.title}>{title}</h3>
            <div className={styles.image}>
              <img src={imageURL} alt="" />
            </div>
            <MarkdownContent className={styles.copy}>{text}</MarkdownContent>
          </div>
        ))}
      </div>
    </SectionWrapper>
  )
}
